import { FC } from 'react';
import { modalMessages } from '../config';

export const ExtensionModalOptions: FC = () => (
  <div className="flex gap-4 mb-8">
    {modalMessages.items.map(({ id, text, image, isComingSoon }) => (
      <div
        className="flex flex-col justify-between items-center gap-4"
        key={id}
      >
        <img alt="cover size hint" className="w-66" src={image} />
        <p className="w-[232px] text-center text-sm text-gray-600">
          {text}
          {isComingSoon && (
            <span className="text-xs text-gray-500 italic">
              {' '}
              (coming soon).
            </span>
          )}
        </p>
      </div>
    ))}
  </div>
);
